import { render, staticRenderFns } from "./modal.vue?vue&type=template&id=3f84601c&scoped=true&"
var script = {}
import style0 from "./modal.vue?vue&type=style&index=0&id=3f84601c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f84601c",
  null
  
)

export default component.exports